// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__gbKo3","content":"Modal_content__7+2VX","header":"Modal_header__2o0QH","close":"Modal_close__ym5tY"};